import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

const CalenderConsentSuccess = () => {
  const goToDashboard = () => {
    window.location.href = '/dashboard'; // change as needed
  };

  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
      }}
    >
      <Card
        title="Google Calendar Connected"
        subTitle="Your calendar is successfully linked"
        style={{
          width: '400px',
          textAlign: 'center',
          borderRadius: '16px',
          boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
          background: '#fff',
        }}
      >
        <i
          className="pi pi-check-circle"
          style={{ fontSize: '4rem', color: '#1976d2', marginBottom: '1rem' }}
        ></i>

        <Divider />

        <Button
          label="Go to Home"
          icon="pi pi-arrow-right"
          onClick={goToDashboard}
          className="p-button-rounded"
          style={{ background: '#1976d2', border: 'none' }}
        />
      </Card>
    </div>
  );
};

export default CalenderConsentSuccess;
